export default __webpack_public_path__ + "static/AreYouReadyBackground-346772a73aff01f24ebf7b9c34e3ed92.png";